import { AxiosError } from 'axios'
import { Form, Formik } from 'formik'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import * as Yup from 'yup'
import { KTSVG } from '../../../../_metronic/helpers'
import { ICreateUser } from '../../../common/interfaces/user.interface'
import { apiUrl } from '../../../config/api'
import { customSwal } from '../../../config/swal'
import { AddUserForm } from './components/form/AddUserForm'

const addUserSchema = Yup.object().shape({
  name: Yup.string().required('Nombre es requerido'),
  lastname: Yup.string().required('Apellido es requerido'),
  username: Yup.string().required('Alias es requerido'),
  email: Yup.string()
    .email('Formato de correo electronico inválido')
    .required('Correo electrónico es requerido'),
  phone_number: Yup.string()
    .max(12, 'Debe tener menos de 12 caracteres')
    .required('Número de teléfono es requerido'),
  password: Yup.string().required('Contraseña es requerida'),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password'), null], 'La contraseña no coinciden')
    .required('Contraseña de  confirmación es requerida'),
  roles: Yup.array().of(Yup.number()).required('El rol es requerido'),
})

const inits: ICreateUser = {
  name: '',
  lastname: '',
  username: '',
  email: '',
  password: '',
  passwordConfirmation: '',
  phone_number: '',
  roles: '',
}

export const AddUser = () => {
  const navigate = useNavigate()
  return (
    <React.Fragment>
      <div className='position-relative'>
        <div className='d-flex flex-row-fluid flex-center bg-body rounded'>
          <Formik
            validationSchema={addUserSchema}
            initialValues={inits}
            onSubmit={async (values) => {
              try {
                await apiUrl.post('/user/person/create', values)
                customSwal
                  .fire({
                    title: 'Usuario creado satisfactoriamente',
                    icon: 'success',
                    allowOutsideClick: false,
                  })
                  .then((result) => {
                    result.isConfirmed && navigate('/user/list')
                  })
              } catch (err: any) {
                const errors = err as AxiosError
                if ((errors.response?.data as any).message.includes('user')) {
                  customSwal.fire({
                    icon: 'error',
                    title: 'El usuario se encuentra en uso.',
                    text: 'Intente nuevamente.',
                  })
                  return
                }
                if ((errors.response?.data as any).message.includes('email')) {
                  customSwal.fire({
                    icon: 'error',
                    title: 'El correo se encuentra en uso.',
                    text: 'Intente nuevamente.',
                  })
                  return
                }
                if ((errors.response?.data as any).message.includes('phone')) {
                  customSwal.fire({
                    icon: 'error',
                    title: 'El número de teléfono se encuentra en uso.',
                    text: 'Intente nuevamente.',
                  })
                  return
                }
                if (errors.response?.data) {
                  customSwal.fire({
                    icon: 'error',
                    title:
                      errors.response.status === 403
                        ? 'No tienes permisos para realizar esta acción'
                        : 'Ha ocurrido un error',
                    text: 'Intente nuevamente.',
                  })
                  return
                }
              }
            }}
          >
            {(props) => (
              <Form
                autoComplete='off'
                className='w-100 w-xl-700px mb-20 '
                onSubmit={props.handleSubmit}
                noValidate
                id='kt_create_account_form'
              >
                <div className='current' data-kt-stepper-element='content'>
                  <div className='mt-20 w-100'>
                    <AddUserForm formProps={props} />
                  </div>
                </div>

                <div className='d-flex flex-end pt-10'>
                  <button
                    type='submit'
                    style={{
                      backgroundColor: '#0066CC',
                      color: 'white',
                    }}
                    className='btn btn-lg'
                    disabled={props.isSubmitting}
                  >
                    <span className='indicator-label'>
                      {'Enviar'}
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 text-white ms-2 me-0'
                      />
                    </span>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}
